export var DEPLOY_DATE = new Date('2026-07-22T08:41:10+0000');
